import { Text } from "@/components/Typography/Text";
import { useCommonTranslation } from "@/hooks/useCommonTranslation";
import type { Attribute, FieldValueType } from "../../types";
import { getAttributeOptions } from "../../utils/option-utils";
import { getDisplayLabel } from "../../utils/value-label-utils";

interface ReadOnlyFieldProps {
  value: FieldValueType;
  field: Attribute;
}

/**
 * 文字列以外の値のフォーマット処理
 */
function formatNonStringValues(value: FieldValueType): string {
  if (value instanceof Date) {
    return value.toLocaleDateString();
  }
  if (Array.isArray(value)) {
    // 配列の場合、各要素を文字列に変換してからjoin
    return value
      .map((item) =>
        typeof item === "object" && item !== null
          ? JSON.stringify(item)
          : String(item),
      )
      .join(", ");
  }
  return String(value);
}

/**
 * ReadOnlyField用の表示ラベル取得
 */
function getReadOnlyDisplayLabel(
  value: FieldValueType | undefined,
  field?: Attribute,
): string {
  if (value instanceof Date || Array.isArray(value)) {
    return formatNonStringValues(value);
  }

  if (value === null || value === undefined) {
    return "";
  }

  const options = field && getAttributeOptions(field);
  return getDisplayLabel(value, options);
}

export const ReadOnlyField = ({ value, field }: ReadOnlyFieldProps) => {
  const tc = useCommonTranslation();
  const displayValue =
    value !== null && value !== undefined && value !== ""
      ? getReadOnlyDisplayLabel(value, field)
      : tc("unregistered");

  return (
    <Text
      variant="labelSemiLarge"
      breakWord
      className="text-neutral-on-fill whitespace-pre-wrap"
    >
      {displayValue}
    </Text>
  );
};
